export function formatIpChain(chain: string[]): string | null {
  if (!chain || chain.length === 0) {
    return null;
  }
  const normalized = chain
    .map(value => value.trim())
    .filter((value, index, array) => value.length > 0 && array.indexOf(value) === index);
  if (!normalized.length) {
    return null;
  }
  if (normalized.length === 1) {
    return normalized[0] ?? null;
  }
  return normalized.join(" | ");
}

export function classifyIp(ip: string): "ipv4" | "ipv6" | "unknown" {
  if (!ip) return "unknown";
  const trimmed = ip.trim();

  // IPv4 pattern: digits and dots
  if (/^(\d{1,3}\.){3}\d{1,3}$/.test(trimmed)) {
    return "ipv4";
  }

  // IPv6 pattern: contains colons
  if (trimmed.includes(":")) {
    return "ipv6";
  }

  return "unknown";
}

export type ClassifiedIp = {
  address: string;
  type: "ipv4" | "ipv6" | "unknown";
  label: string;
};

export function classifyIpChain(chain: string[]): ClassifiedIp[] {
  if (!chain || chain.length === 0) {
    return [];
  }

  const normalized = chain
    .map(value => value.trim())
    .filter((value, index, array) => value.length > 0 && array.indexOf(value) === index);

  return normalized.map(address => {
    const type = classifyIp(address);
    const label = type === "ipv4" ? "IPv4" : type === "ipv6" ? "IPv6" : "IP";
    return { address, type, label };
  });
}

export function extractIpv4FromChain(chain: string | null): string | null {
  if (!chain) return null;

  // Split by pipe separator and find the first IPv4 address
  const ips = chain.split("|").map(ip => ip.trim());
  for (const ip of ips) {
    if (classifyIp(ip) === "ipv4") {
      return ip;
    }
  }

  return null;
}
